import { AxiosResponse } from 'axios'
import { API } from './index'
import {
  azureEngineServiceUrl,
  cloudAccountServiceUrl,
} from '../utils/constants'
import type { CloudType, ProductType } from '../types'

const cloudTypeToApiValue = (cloudType: string) =>
  cloudType === 'AZURE' ? 'AZ' : cloudType

export const fetchFlyoutAccountDetails = (
  _name: string,
  cloudType: string,
  productId: string,
  partnerId: string
) => {
  return API.get(`${cloudAccountServiceUrl}/templates`, {
    params: {
      cloud_type: cloudType,
      partner_id: partnerId,
      product_id: productId,
    },
  })
}

export const getUrlFromCloudAccount = (partnerId: string) => {
  return API.get(
    `${azureEngineServiceUrl}/oauth/${partnerId}/auth_response/azure`
  )
}

export const sendAzureData = (
  dataToSend: Record<string, unknown>,
  partnerId: string
) => {
  return API.post(
    `${azureEngineServiceUrl}/oauth/${partnerId}/tokens/azure`,
    dataToSend
  )
}

export const sendAzurePartnerData = (
  dataToSend: Record<string, unknown>,
  partnerId: string
) => {
  return API.put(`${azureEngineServiceUrl}/partners/${partnerId}`, dataToSend)
}

export const fetchOrganizationAccounts = (
  organizationId: string,
  cloudType: CloudType | string,
  productId?: ProductType | string
): Promise<AxiosResponse<{ rows: unknown[] }>> =>
  API.get(`${cloudAccountServiceUrl}/accounts`, {
    params: {
      cloud_type: cloudTypeToApiValue(cloudType),
      organization_id: organizationId,
      product_id: productId ? productId : '',
    },
  })
